module.exports = __webpack_public_path__ + "img/result-05.cf618fce.svg";